import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "reactstrap";
import {
  getBannerList,
} from "../../redux/actions/indexActions";
import { AiOutlineEdit, AiOutlineDelete, AiFillEye } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import { MdAdd } from "react-icons/md";
import { Input } from "reactstrap";
import Pagination from "../../Components/Paginate";
import { RxVideo } from "react-icons/rx";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactPlayer from "react-player";
import { CSVLink } from 'react-csv';
import { BiSolidFileExport } from 'react-icons/bi';

const Banner = () => {
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
    indexReducer: {
      bannerlists,
      bannerCount,
    },
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const [paginate, setPaginate] = useState(10);
  const [url, setUrl] = useState(false);
  const [modal, setModal] = useState(false);
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  useEffect(() => {
    dispatch(getBannerList(auth?.token, paginate, page, search, sort))
  }, [auth, paginate, page, search, sort]);

  const csvHead = [['title', 'type', 'location', 'description', 'thumbnail', 'video url']]
  const csvData = bannerlists.map((cv) => [
    cv?.title,
    cv?.type == 1 ? 'Image' : 'Video',
    cv?.location,
    cv?.description,
    cv?.thumbnail,
    cv?.video_url
  ])
  const exportData = csvHead.concat(csvData);

  const handleDel = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This Banner")) {
      axios
        .delete(`/api/admin/v1/banner-delete/${id}`, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.message);
          dispatch(getBannerList(auth?.token));
        })
        .catch((err) => toast.error("Somthing Went Wrong"));
    }
  };

  const handleVideo = (e, url) => {
    e.preventDefault();
    setUrl(url);
    setModal(true);
  };

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="mb-4 d-flex align-items-center justify-content-between">
            <h5 className="mb-0 text-white fs-4">Banner List</h5>
            {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "BANNERLIST" && item?.permission?.permission === "create") && (
              <Link to="/add-banner">
                <Button className="bg-white text-black" size="sm">
                  <span className="me-2">
                    <MdAdd size={22} />
                  </span>
                  Add Banner
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4" style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}>

        <div className="row">
          <div className="col-md-3 mb-2">
            <Input size={"sm"} value={search} placeholder='Search By Name' onChange={(({ target: { value } }) => setSearch(value))} />
          </div>
          <div className={`col-md-2 ${allowedPermissions?.some?.(
            (item) =>
              item?.permission?.moduleType === "BANNERLIST" &&
              item?.permission?.permission === "export"
          ) ? "offset-md-6" : "offset-md-7"}`}>
            <Input type="select" size={"sm"} value={sort} onChange={(({ target }) => setSort(target.value))} >
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </Input>
          </div>
          {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "BANNERLIST" && item?.permission?.permission === "export") && (
            <div className="col-md-1 mb-2">
              <CSVLink
                filename={
                  "banner-lists.csv"
                }
                className="text-black ms-1"
                title="Export To CSV"
                data={exportData}
              >
                <BiSolidFileExport size={25} />
              </CSVLink>
            </div>
          )}
          <div className="col-md-12">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>SL. No.</th>
                  <th>Title</th>
                  <th>Banner</th>
                  <th>Video</th>
                  {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "BANNERLIST" && (item?.permission?.permission === "edit" || item?.permission?.permission === "delete")) && (
                    <th>Action</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {bannerlists.length === 0 ? (
                  <tr>
                    <td colSpan="6">No data found</td>
                  </tr>
                ) : (<>
                  {bannerlists?.map?.((item, index) => {
                    return (
                      <tr key={item.id}>
                        <th scope="row">{index + 1 + page * paginate}</th>
                        <td>{item?.title}</td>
                        <td>
                          {item.thumbnail ? (
                            <img
                              src={process.env.REACT_APP_IMAGE_URL + `/${item?.thumbnail}`}
                              height={45}
                              width={45}
                            />
                          ) : null}
                        </td>
                        <td>
                          {item.video_url ? (
                            <a
                              role="button"
                              className=""
                              onClick={e =>
                                handleVideo(
                                  e,
                                  item.video_url
                                )
                              }>
                              <RxVideo fontSize={20} />
                            </a>
                          ) : null}
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "BANNERLIST" &&
                                item?.permission?.permission === "edit"
                            ) && (
                                <Link to={`/banner-update/${item?.id}`}>
                                  <AiOutlineEdit
                                    size={22}
                                    className="text-warning me-3"
                                  />
                                </Link>
                              )}
                            {allowedPermissions?.some?.(
                              (item) =>
                                item?.permission?.moduleType ===
                                "BANNERLIST" &&
                                item?.permission?.permission === "delete"
                            ) && (
                                <AiOutlineDelete
                                  size={22}
                                  className="text-danger"
                                  onClick={() => handleDel(item.id)}
                                />
                              )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}</>
                )}
              </tbody>
            </Table>
          </div>
        </div>
        <Modal isOpen={modal} toggle={() => setModal(false)} size="lg">
          <ModalBody className="p-0">
            <ReactPlayer
              url={url}
              playing
              width="100%"
              controls={true}
            />
          </ModalBody>
        </Modal>
        <div className="row align-items-center">
          <div className="col-md-6 d-flex">
            <div className="col-md-2">
              <Input
                type="select"
                id="paginate"
                onChange={e =>
                  setPaginate(
                    e.target.value
                  )
                }
                value={paginate}
                className="paging custom-select custom-select-page m-0"
              >
                <option value="10">
                  10
                </option>
                <option value="20">
                  20
                </option>
                <option value="50">
                  50
                </option>
                <option value="100">
                  100
                </option>
                <option value="200">
                  200
                </option>
                <option value="500">
                  500
                </option>
              </Input>
            </div>
            <div className='col-md-10 text-black d-flex align-items-center ps-3'>
              {bannerCount > 0 ? (
                <>
                  Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, bannerCount)} of {bannerCount} entries
                </>
              ) : (
                <>
                  Showing 0 to 0 of 0 entries
                </>
              )}
            </div>
          </div>
          <div className='col-md-6'>
            <div className='d-flex justify-content-end'>
              <Pagination
                pageCount={(bannerCount) / paginate}
                onChange={(e) => setPage(e.selected)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
